interface OnboardingHeaderProps {
  userName: string;
}

export const OnboardingHeader = ({ userName }: OnboardingHeaderProps) => (
  <header className="space-y-2">
    <h1 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">Bonjour {userName}.</h1>
    <p className="max-w-xl text-sm text-muted-foreground sm:text-base">
      Finalisez la configuration de vos rôles pour accéder à OO Connect.
    </p>
  </header>
);
